import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";
import { Provider } from "react-redux";
import React from "react";

import Footer from "./components/layout/footer";
import Header from "./components/layout/header";
import IndexPage from "./components/index/index-page";
import Register from "./components/register/register-page";
import Cart from "./components/cart/cart-page";
import Project from "./components/index/projectname";
import Loading from "./components/layout/loading";
import Outtime from "./components/outtime/outtime";
import LoginCallback from "./components/login/login-callback";
import AlertBox from "./components/layout/alertbox";
import Notfound from "./components/outtime/notfound";

import store from "./store";

// import CallApi from "./util/CallApi";

// const callApi = new CallApi();

function checkLogin() {
  console.log('checkLogin first')
  if (localStorage.getItem("access_token")) {
    return true;
  } else {
    return false;
  }
}

function App() {

  let path = "/notfound";
  if (localStorage.getItem("project_id")) {
    path = "/shop/" + localStorage.getItem("project_id");
  }

  const PrivateRoute = ({ component: Component, ...rest }) => {
    console.log('Set Init PrivateRoute');
    // const gtknResp = callApi.setSysToken().then(data => {
    //   if (parseInt(data.code) === 200) {
    //     localStorage.setItem('sys_token', data.token);
    //   }

    //   return data;
    // });

    // const gtknResp = callApi.post("/login/gtkn", {}).then(data => {
    //   if (parseInt(data.code) === 200) {
    //     localStorage.setItem('sys_token', data.token);
    //   }

    //   return data;
    // });

    // console.log(gtknResp);

    return (
      <Route
        {...rest}
        render={props =>
          checkLogin() ? ( /// condition login
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: path,
                state: { from: props.location }
              }}
            />
          )
        }
      />
    )
  };

  const GeneralRoute = ({ component: Component, ...rest }) => {
    console.log('Set Init GeneralRoute');
    // const gtknResp = callApi.setSysToken().then(data => {
    //     if (parseInt(data.code) === 200) {
    //       localStorage.setItem('sys_token', data.token);
    //     }
    //   });
    // const gtknResp = callApi.post("/login/gtkn", {}).then(data => {
    //   if (parseInt(data.code) === 200) {
    //     localStorage.setItem('sys_token', data.token);
    //   }

    //   return data;
    // });

    // console.log(gtknResp);

    return (
      <Route
        {...rest}
        render={props => (<Component {...props} />)}
      />
    )
  };

  return (
    <Provider store={store}>
      <Router basename={process.env.PUBLIC_URL}>
        <Loading />
        <Header />
        <Project />
        <AlertBox />
        <main role="main" className="container_main">
          <Switch>
            <GeneralRoute path="/shop/:project" exact component={IndexPage} />
            {/* <PrivateRoute path="/shop/:project" exact component={IndexPage} /> */}
            <PrivateRoute path="/register/" component={Register} />
            <PrivateRoute path="/cart/" component={Cart} />
            <GeneralRoute path="/outtime/" component={Outtime} />
            <GeneralRoute path="/callback" component={LoginCallback} />
            <GeneralRoute
              path="/notfound"
              component={() => <Notfound>ไม่พบหน้านี้</Notfound>}
            />
            <GeneralRoute component={() => <Notfound>ไม่พบหน้านี้</Notfound>} />
          </Switch>
        </main>
      </Router>
      <Footer />
    </Provider>
  );
}

export default App;
